/**
 * @file        src/components/ToastHost.jsx
 * @description Renders the active toast queue.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
import { useEffect, useState } from 'react';
import { useToasts } from '../lib/toast';
import Icon from './Icon';

function Item({ t }) {
  const [show, setShow] = useState(false);
  useEffect(() => { const id = requestAnimationFrame(() => setShow(true)); return () => cancelAnimationFrame(id); }, []);
  const icon = t.type === 'ok' ? 'check' : t.type === 'err' ? 'x' : 'bell';
  return (
    <div className={`toast ${t.type} ${show ? 'show' : ''}`}>
      <span className="toast-ic"><Icon name={icon} size={21} /></span>
      <div>
        <b>{t.title}</b>
        {t.msg ? <small>{t.msg}</small> : null}
      </div>
    </div>
  );
}

export default function ToastHost() {
  const items = useToasts((s) => s.items);
  return (
    <div className="toast-wrap" role="status" aria-live="polite">
      {items.map((t) => <Item key={t.id} t={t} />)}
    </div>
  );
}
